import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AnimationsService, RestService } from "@stdoutsrl/design-kit"
import { api } from "../../environments/environment";
import { Message } from "@stdoutsrl/design-kit";
import { io, Socket } from 'socket.io-client';
import { LoaderService } from "../service/loader.service";
import { mapOptions } from "../models/map-options";

@Component({
  selector: 'app-presentation',
  templateUrl: './presentation.component.html',
  styles: [],
  standalone: false,
})
export class PresentationComponent implements OnInit {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message,
    private activatedRoute: ActivatedRoute,
    private animationService: AnimationsService,
  ) {}
  emojiList: string[] = [
    '😀',
    '🥳',
    '😇',
    '🤠',
    '🤑',
    '🤓',
    '🤡',
    '😈',
    '👻',
    '💀',
    '🤖',
    '👹',
    '⛄',
    '👽',
    '🌞',
    '😺',
    '🙉',
    '⭐',
    '❤️',
    '💜',
    '🖤',
    '🦴',
    '🦷',
    '🌹',
    '🍀',
    '🍄',
    '🦁',
    '🐶',
    '🐺',
    '🐻',
    '🐻‍❄️',
    '🐨',
    '🐼',
    '🐹',
    '🐭',
    '🐰',
    '🦊',
    '🐮',
    '🐷',
    '🦄',
    '🐴',
    '🐢',
    '🐸',
    '🦉',
    '🍎',
    '🍓',
    '🍊',
    '🥭',
    '🥦',
    '🌰',
    '🍔',
    '🦞',
    '🍙',
    '🍥',
    '🍿',
    '🧁',
    '🍩',
  ];
  origin = '';
  correctNumberAnswer = 0;
  idLive = '';
  loopQuizCountdownTimer : any
  animatedButton = '';
  currentStep = -2;
  timerStart = 5; // Da cambiare a 5 timer
  qrCode = '';
  baseTimer = 10;
  userToShow = -1;
  users: {
    nickname: string;
    points: number;
    profile_icon: string;
    color?: string;
  }[] = [];
  presentationHasStarted = false;
  private socket!: Socket;
  urlSocket: string = api.socketUrl;
  quiz: any = {};
  session: any = {};
  timerQuestionMinut5Second :any
  timerQuestion: any;
  timerQuestionStartDate: any;
  barTimeStopped = false;
  remainingTimeTimer: number = -1;
  showTimer = false;
  endQuiz = false;
  showRank = false;
  endedTimeQuestion = false;
  rankedUsers: any[] = [];
  winBuzzer = false;
  reservedUser: any;
  everyoneAnswered = false;
  totalAnswered = 0;
  showCorrectAnswer = false;
  usersAnswers: any[] = [];
  mapOptions: any = mapOptions;
  markerOptions = {
    icon: {
      path: google.maps.SymbolPath.CIRCLE,
      fillColor: '#4ade80',
      fillOpacity: 1,
      strokeColor: '#ffffff',
      strokeWeight: 2,
      scale: 10,
    },
  };
  mapZoom = 20;
  mapZoom2 = 20;
  minNumber = 0;
  maxNumber = 0;
  showAnimationWrong = false;
  showAnimationTimeout = false;
  showCurrentTempRank = false;
  showCompleteRank = false;
  currentAudio: any;

  ngOnInit(): void {
    setTimeout(() => {
      let body = document.body;
      if (!document.fullscreenElement) {
        body.requestFullscreen();
      }
    }, 0);

    this.idLive = this.activatedRoute.snapshot.paramMap.get('id')!;
    this.origin = window.location.host;

    this.qrCode = `${this.origin}/live/${this.idLive}`;

    if (this.idLive) {
      this.getEventDetails();
    } else {
      this.message.showMessage('Insert live id', 'error');
    }
  }

  toFloat(number: string) {
    return parseFloat(number);
  }

  getHList() {
    return parseInt(((window.innerHeight - 160) / 80).toString()) * 80 + 'px';
  }

  activateFullScreen() {
    let body = document.body;
    if (!document.fullscreenElement) {
      body.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  }

  connectToSocket() {
    this.socket = io(this.urlSocket, {
      transports: ['websocket'],
      auth: {
        joinCode: this.idLive,
        token: localStorage.getItem('token'),
        liveId: this.session.id,
      },
    });
    this.socket.on('connected', (socket) => {
      this.users = socket.users.map((res: any) => {
        return JSON.parse(res);
      });
      if (this.session.ended_at) {
        this.endQuiz = true;
        this.animationService.launchConfetti(100);
        this.currentStep = this.quiz.questions.length;
        this.free('end');
        this.getRankedUsers();
      }
    });
    this.listToAllEvents();
  }

  listToAllEvents() {
    this.u1();
    this.u2();
    this.u3();
    this.u4();
    this.u5();
    this.reserveBuzzer();
    this.userAnswered();
    this.completedBuzzer();
    this.questionEnded();
    this.buzzerTimeout();
    this.error();
  }

  u1() {
    this.socket.on('u1', (event) => {
      let myUser = this.users.find((user: any) => user.id == event.id);
      if (myUser) {
        this.users[this.users.findIndex((user: any) => user.id == event.id)] =
          event;
      } else {
        this.users.push(event);
      }
    });
  }

  u2() {
    this.socket.on('u2', (event) => {
      let myIndex = this.users.findIndex((user: any) => user.id == event.id);
      this.users[myIndex].color = event.value;
      setTimeout(() => {
        myIndex = this.users.findIndex((user: any) => user.id == event.id);
        this.users[myIndex].color = 'rgba(255, 255, 255 ,0.25)';
      }, 1000);
    });
  }

  u3() {
    this.socket.on('u3', (event) => {
      console.log('Evento socket3:', event);
    });
  }

  u4() {
    this.socket.on('u4', (event: any) => {
      console.log('Evento socket4:', event);
      this.generateEmoji(event.value);
    });
  }

  u5() {
    this.socket.on('u5', (event) => {
      console.log('Evento socket5:', event);
    });
  }

  reserveBuzzer() {
    this.socket.on('buzzer-reserved', (event) => {
      this.reservedUser = event;
      this.playAudio('./assets/sounds/BuzzerQuestionPrenotazione.wav');
    });
  }

  userAnswered() {
    this.socket.on('user-answered', (event) => {
      this.reservedUser = null;
      this.totalAnswered = this.totalAnswered + 1;
      if (this.quiz.questions[this.currentStep].type == 3) {
        event.lat = this.toFloat(event.answer.split(',')[0]);
        event.lng = this.toFloat(event.answer.split(',')[1]);
      }
      let newAnswer = event;
      let user = this.users.find((user: any) => user.id == newAnswer.userId);
      if (user) {
        newAnswer.profile_icon = user.profile_icon;
        newAnswer.nickname = user.nickname;
      }
      this.usersAnswers.push(event);
      if (this.quiz.questions[this.currentStep].type == 4) {
        let maxNumber = parseFloat(
          this.usersAnswers.reduce((max, current) =>
            parseFloat(current.answer) > parseFloat(max.answer) ? current : max,
          ).answer,
        );
        let minNumber = parseFloat(
          this.usersAnswers.reduce((min, current) =>
            parseFloat(current.answer) < parseFloat(min.answer) ? current : min,
          ).answer,
        );
        let diff = maxNumber - minNumber;
        this.minNumber = minNumber - parseInt((diff / 10).toString()) - 1;
        this.maxNumber = maxNumber + parseInt((diff / 10).toString()) + 1;

        this.usersAnswers.map((userAnswer: any) => {
          if (minNumber === maxNumber) {
            userAnswer.left = 'calc(50% - 20px)';
          } else {
            let difference = parseFloat(userAnswer.answer) - this.minNumber;
            let diffMaxMin = this.maxNumber - this.minNumber;
            userAnswer.left = `calc(${(difference / diffMaxMin) * 100}% - 20px)`;
          }
          let userToAnswer = this.users.find(
            (user: any) => user.id == userAnswer.userId,
          );
          if (userToAnswer) {
            userAnswer.emoji = userToAnswer.profile_icon;
          }
          return userAnswer;
        });
      }
      if (this.totalAnswered == this.users?.length) {
        this.everyoneAnswered = true;
        // this.endQuestion()
      }
      if (
        this.quiz.questions[this.currentStep].type == 2 &&
        event.answer != this.quiz.questions[this.currentStep].correct_value
      ) {
        this.showAnimationWrong = true;
        this.playAudio('./assets/sounds/BuzzerQuestionWrongAnswer.wav');
        setTimeout(() => {
          this.showAnimationWrong = false;
        }, 500);
      }
    });
  }

  questionEnded() {
    this.socket.on('question-ended', (event) => {
      this.currentAudio?.pause()
      this.everyoneAnswered = true;
      if (!this.barTimeStopped) {
        this.stopBarTimer();
      }
      this.endQuestion();
    });
  }

  buzzerTimeout() {
    this.socket.on('buzzer-timeout', (event) => {
      this.totalAnswered = this.totalAnswered + 1;
      this.reservedUser = null;
      this.showAnimationTimeout = true;
      this.playAudio('./assets/sounds/BuzzerQuestionWrongAnswer.wav');
      setTimeout(() => {
        this.showAnimationTimeout = false;
      }, 500);
    });
  }

  completedBuzzer() {
    this.socket.on('complete_buzzer', (event) => {
      this.winBuzzer = true;
      this.reservedUser = null;
      if (!this.barTimeStopped) {
        this.stopBarTimer();
      }
      this.endQuestion();
    });
  }

  error() {
    this.socket.on('error', (error) => {
      console.error('Errore Socket.IO:', error);
    });
  }

  generateEmoji(emoji: string) {
    let id = Math.floor(Math.random() * 1000000);
    let myFountain = document.getElementById('fountain');
    if (myFountain) {
      let myNewEmoji = document.createElement('div');
      myNewEmoji.style.fontSize = '40px';
      myNewEmoji.innerHTML = emoji;
      myNewEmoji.id = id.toString();
      let myXPosition = Math.floor(Math.random() * (100 - -100 + 1)) - 100;

      const animationName = 'floatUp';
      const keyframes = `
@keyframes ${animationName + id} {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  10% {
    transform: translateY(-50px) translateX(${
      myXPosition * 0.1
    }px) rotate(50deg)
  };
  20% {
    transform: translateY(-50px) translateX(${
      myXPosition * 0.2
    }px) rotate(100deg)
  };
  30% {
    transform: translateY(-50px) translateX(${
      myXPosition * 0.3
    }px) rotate(150deg)
  };
  40% {
    transform: translateY(-50px) translateX(${
      myXPosition * 0.4
    }px) rotate(200deg)
  };
  50% {
    transform: translateY(-50px) translateX(${
      myXPosition * 0.5
    }px) rotate(250deg)
  };
  60% {
    transform: translateY(-50px) translateX(${
      myXPosition * 0.6
    }px) rotate(300deg)
  };
  70% {
    transform: translateY(-50px) translateX(${
      myXPosition * 0.7
    }px) rotate(350deg)
  };
  80% {
    transform: translateY(-50px) translateX(${
      myXPosition * 0.8
    }px) rotate(400deg);
        opacity: 1;
  }
  100% {
    transform: translateY(10px) translateX(${myXPosition}px) rotate(500deg);
        opacity: 0;
  }
}

.${animationName + id + 'class'}{
  animation: ${animationName + id} 2.5s ease;
  position:absolute
}
`;
      const styleSheet = document.createElement('style');
      styleSheet.innerHTML = keyframes;
      document.body.appendChild(styleSheet);
      myNewEmoji.className = animationName + id + 'class';
      myFountain.appendChild(myNewEmoji);
      setTimeout(() => {
        myNewEmoji.remove();
        styleSheet.remove();
      }, 2499);
    }
  }

  getEventDetails() {
    this.loader.on();
    this.rest.get(`/quiz-session/${this.idLive}`).subscribe({
      next: (value: any) => {
        this.quiz = value.quiz;
        this.session = value;
        if (value.status === 2) {
          this.currentStep = -1;
          this.timeStart();
          this.playAudio('./assets/sounds/GameStartCountdown5.wav');
        } else {
          this.loopWaitingPlayers();
        }
        this.loader.off(true);
        this.connectToSocket();
      },
      error: (value) => {
        this.loader.off(true);
      },
    });
  }

  loopWaitingPlayers() {
    this.currentAudio = new Audio(
      './assets/sounds/WaitingParticipantsLoop.wav',
    );
    this.currentAudio.play();
    setTimeout(() => {
      if(this.currentStep == -2){
      this.loopWaitingPlayers();}
    }, 9000);
  }

  loopQuizCountdown(remainingTime?:number) {
    let remainingTimeCalc = remainingTime ? remainingTime : (this.quiz.questions[this.currentStep].question_settings
          .duration_seconds ?? this.baseTimer) * 1000
    this.currentAudio = new Audio(
      './assets/sounds/QuizCountdownLoop.wav',
    );
    this.currentAudio.play();
    this.loopQuizCountdownTimer = setTimeout(() => {
      if(!this.endedTimeQuestion && remainingTimeCalc >= 9000){
      this.loopQuizCountdown(remainingTimeCalc - (this.barTimeStopped ? 0 :4000));}
    }, 4000);
  }

  activateAnimation(button: string) {
    this.animatedButton = button;
    setTimeout(() => {
      this.animatedButton = '';
    }, 1000);
  }

  timeStart() {
    if (this.timerStart > 0) {
      setTimeout(() => {
        this.timerStart = this.timerStart - 1;
        this.timeStart();
      }, 999);
    } else {
      this.currentStep = this.session?.current_question?.order_index - 1;
      this.showTimer = true;
      setTimeout(() => {
        this.loader.on();
        this.rest
          .patch(`/quiz-session/${this.session.id}/start`, {})
          .subscribe({
            next: (value) => {
              this.sendQuestion();
              this.loader.off(true);
            },
            error: (value) => {
              this.loader.off(true);
            },
          });
      }, 100);
    }
  }

  playAudio(path: string) {
    const audio = new Audio(path);
    audio.play();
  }

  showCorrectQuestionAnswer() {
    this.showCorrectAnswer = true;
    if (this.quiz.questions[this.currentStep].type == 4) {
      this.playAudio('./assets/sounds/DrumRoll.wav');
      let maxNumber = parseFloat(
        this.usersAnswers.reduce((max, current) =>
          parseFloat(current.answer) > parseFloat(max.answer) ? current : max,
        ).answer,
      );
      let minNumber = parseFloat(
        this.usersAnswers.reduce((min, current) =>
          parseFloat(current.answer) < parseFloat(min.answer) ? current : min,
        ).answer,
      );
      if (minNumber > this.quiz.questions[this.currentStep].correct_value) {
        minNumber = parseFloat(
          this.quiz.questions[this.currentStep].correct_value,
        );
      }
      if (maxNumber < this.quiz.questions[this.currentStep].correct_value) {
        maxNumber = parseFloat(
          this.quiz.questions[this.currentStep].correct_value,
        );
      }
      let diff = maxNumber - minNumber;
      this.minNumber = minNumber - parseInt((diff / 10).toString()) - 1;
      this.maxNumber = maxNumber + parseInt((diff / 10).toString()) + 1;
      this.usersAnswers.map((userAnswer: any) => {
        if (minNumber === maxNumber) {
          userAnswer.left = 'calc(50% - 20px)';
        } else {
          let difference = parseFloat(userAnswer.answer) - this.minNumber;
          let diffMaxMin = this.maxNumber - this.minNumber;
          userAnswer.left = `calc(${(difference / diffMaxMin) * 100}% - 20px)`;
        }
        let userToAnswer = this.users.find(
          (user: any) => user.id == userAnswer.userId,
        );
        if (userToAnswer) {
          userAnswer.emoji = userToAnswer.profile_icon;
        }
        return userAnswer;
      });
      setTimeout(() => {
        const barNumber = document.getElementById(
          'numeric-answer-correct-number-bar',
        );
        const barTip = document.getElementById('numeric-answer-correct-number');

        const correctValue =
          this.quiz.questions[this.currentStep].correct_value;
        const minValue = this.minNumber;

        this.correctNumberAnswer = minValue;

        if (barNumber && barTip) {
          const difference = correctValue - minValue;
          const diffMaxMin = this.maxNumber - minValue;
          const percentage = (difference / diffMaxMin) * 100;

          const duration = 8000;
          setTimeout(() => {
            const minDifference = Math.min(
              ...this.usersAnswers.map((a) =>
                Math.abs(a.answer - correctValue),
              ),
            );
            this.usersAnswers = this.usersAnswers.map((a) => ({
              ...a,
              ...(Math.abs(a.answer - correctValue) === minDifference
                ? { isBest: true }
                : {}),
            }));
            console.log(this.usersAnswers);
          }, duration - 100);
          const startTime = performance.now();

          barNumber.style.transition = `width ${duration / 1000}s cubic-bezier(0.25, 1, 0.5, 1)`;

          barTip.style.transition = `left ${duration / 1000}s cubic-bezier(0.25, 1, 0.5, 1)`;

          barNumber.style.width = `${percentage}%`;
          barTip.style.left = `${percentage}%`;

          const animateNumber = (currentTime: number) => {
            const progress = Math.min((currentTime - startTime) / duration, 1);

            const easedProgress = 1 - Math.pow(1 - progress, 3);

            this.correctNumberAnswer = parseFloat(
              (minValue + difference * easedProgress).toFixed(0),
            );

            if (progress < 1) {
              requestAnimationFrame(animateNumber);
            } else {
              this.correctNumberAnswer = correctValue;
            }
          };

          requestAnimationFrame(animateNumber);
        }
      }, 0);
    } else {
      if (this.quiz.questions[this.currentStep].type !== 3) {
        this.playAudio('./assets/sounds/ShowingCorrectAnswer.wav');
      }
    }
    if (this.quiz.questions.length > this.currentStep + 1) {
      this.free('showRank');
    }
  }

  startQuiz() {
    this.loader.off(true);
    this.currentStep = -1;
    this.free('start-timer');
    this.currentAudio.pause()
    this.playAudio('./assets/sounds/GameStartCountdown5.wav');
    this.timeStart();
  }

  startBarTimer() {
    let bar = document.getElementById('timer-question');
    if (bar) {
      let totalTimerQuestion =
        (this.quiz.questions[this.currentStep].question_settings
          .duration_seconds ?? this.baseTimer) * 1000;
      this.barTimeStopped = false;
      this.timerQuestionStartDate = new Date().getTime();
      // clearTimeout(this.loopQuizCountdownTimer)
      // this.loopQuizCountdown()
      this.timerQuestion = setTimeout(
        () => {
          this.endQuestion();
        },
        this.remainingTimeTimer == -1
          ? totalTimerQuestion
          : this.remainingTimeTimer,
      );
      this.timerQuestionMinut5Second = setTimeout(
        () => {
          this.currentAudio?.pause()
          this.currentAudio = new Audio('./assets/sounds/QuizCountdownLast5Seconds.wav');
          this.currentAudio.play()
        },
        (this.remainingTimeTimer == -1
          ? totalTimerQuestion
          : this.remainingTimeTimer)-5000,
      );
      if (this.remainingTimeTimer == -1) {
        bar.style.transitionDuration = `${(this.quiz.questions[this.currentStep].question_settings.duration_seconds ?? this.baseTimer) * 1000}ms`;
      } else {
        bar.style.transitionDuration = `${this.remainingTimeTimer}ms`;
      }
      bar.style.width = '0px';
      bar.style.transitionTimingFunction = 'linear';
    }
  }

  stopBarTimer() {
    let bar = document.getElementById('timer-question');
    if (bar) {
      this.barTimeStopped = true;
      clearTimeout(this.timerQuestion);
      clearTimeout(this.timerQuestionMinut5Second)
      let passedTime = new Date().getTime() - this.timerQuestionStartDate;
      let totalTimeQuestion =
        (this.quiz.questions[this.currentStep].question_settings
          .duration_seconds ?? this.baseTimer) * 1000;
      if (this.remainingTimeTimer != -1) {
        totalTimeQuestion = this.remainingTimeTimer;
      }
      let reverseTimer = 0;
      if (this.remainingTimeTimer != -1) {
        reverseTimer =
          (this.quiz.questions[this.currentStep].question_settings
            .duration_seconds ?? this.baseTimer) *
            1000 -
          this.remainingTimeTimer;
      }
      this.remainingTimeTimer = totalTimeQuestion - passedTime;
      let percBar =
        1 -
        (passedTime + reverseTimer) /
          ((this.quiz.questions[this.currentStep].question_settings
            .duration_seconds ?? this.baseTimer) *
            1000);
      bar.style.transitionDuration = `0ms`;
      bar.style.width = (window.innerWidth - 248) * percBar + 'px';
    }
  }

  eventAfterQuestion() {
    if (this.quiz.questions[this.currentStep].type == 3) {
      this.showCorrectQuestionAnswer();
      this.playAudio('./assets/sounds/DrumRoll.wav');
      for (let index = 0; index < 40; index++) {
        setTimeout(() => {
          this.mapZoom = this.mapZoom - 0.5;
        }, index * 250);
      }
    }
    if (
      this.quiz.questions[this.currentStep].type == 1 ||
      this.quiz.questions[this.currentStep].type == 2
    ) {
      let totals = [0, 0, 0, 0, 0];
      this.usersAnswers.forEach((answer: any) => {
        let indexAnswer = this.quiz.questions[
          this.currentStep
        ].question_options.findIndex(
          (quest_opt: any) => quest_opt.option_text == answer.answer,
        );
        if (indexAnswer > -1) {
          totals[indexAnswer] = totals[indexAnswer] + 1;
        }
      });
      totals.forEach((total: number, index) => {
        if (total > 0) {
          this.quiz.questions[this.currentStep].question_options[index].perc =
            Number(((total / this.usersAnswers.length) * 100).toFixed(2));
        } else {
          this.quiz.questions[this.currentStep].question_options[index].perc =
            0;
        }
      });
    }
  }

  endQuestion() {
    this.loader.on();
    this.showTimer = false;
    this.barTimeStopped = false;
    // this.currentAudio.pause()
    setTimeout(() => {
      if (this.quiz.questions.length > this.currentStep + 1) {
        this.remainingTimeTimer = -1;

        setTimeout(() => {
          this.rest
            .patch(`/quiz-session/${this.session.id}/stopTimeQuestion`, {})
            .subscribe({
              next: (value) => {
                this.socket.emit('stopTimeQuestion');
                if (
                  this.quiz.questions[this.currentStep]?.question_settings
                    ?.show_rank
                ) {
                  this.getRankedUsers();
                }

                this.endedTimeQuestion = true;
                this.eventAfterQuestion();
                this.loader.off(true);
              },
              error: (value) => {
                this.socket.emit('stopTimeQuestion');
                if (
                  this.quiz.questions[this.currentStep]?.question_settings
                    ?.show_rank
                ) {
                  this.getRankedUsers();
                }
                this.eventAfterQuestion();
                this.endedTimeQuestion = true;
                this.loader.off(true);
              },
            });
        }, 100);
      } else {
        this.loader.on();
        this.rest
          .patch(`/quiz-session/${this.session.id}/stopTimeQuestion`, {})
          .subscribe({
            next: (value) => {
              this.endedTimeQuestion = true;
              // this.endQuiz = true
              this.terminateQuiz();
              this.totalAnswered = 0;
              // this.currentStep = this.currentStep + 1

              this.eventAfterQuestion();
              this.loader.off();
            },
            error: (value) => {
              this.endedTimeQuestion = true;
              // this.endQuiz = true
              this.terminateQuiz();
              this.totalAnswered = 0;
              // this.currentStep = this.currentStep + 1
              this.eventAfterQuestion();
              this.loader.off();
            },
          });
      }
    }, 0);
  }

  terminateQuiz() {
    this.rest.patch(`/quiz-session/${this.session.id}/end`, {}).subscribe({
      next: (value) => {},
      error: (value) => {},
    });
  }

  free(event: string) {
    this.socket.emit('free', event);
  }

  nextQuestion() {
    if (this.quiz.questions.length > this.currentStep + 1) {
      this.rest.patch(`/quiz-session/${this.session.id}/next`, {}).subscribe({
        next: (value) => {
          this.showCorrectAnswer = false;
          this.winBuzzer = false;
          this.showTimer = true;
          this.endedTimeQuestion = false;
          this.everyoneAnswered = false;
          this.mapZoom = 20;
          this.mapZoom2 = 20;
          this.showCurrentTempRank = false;
          this.showRank = false;
          this.totalAnswered = 0;
          this.currentStep = this.currentStep + 1;
          this.usersAnswers = [];
          this.sendQuestion();
          // this.startBarTimer()
        },
        error: (value) => {},
      });
    } else {
      this.endQuiz = true;
      this.currentStep = this.currentStep + 1;
      this.animationService.launchConfetti(100);
      this.free('end');
      this.free('showRank');
      this.getRankedUsers();
    }
  }

  sendQuestion() {
    this.rest
      .post(`/quiz-session/${this.session.id}/sendQuestion`, {})
      .subscribe({
        next: (value) => {
          this.socket.emit('c1', {});
          const audio = new Audio('./assets/sounds/showQuestion.wav');
          audio.play();
          if (this.quiz.questions[this.currentStep].type == 3) {
            setTimeout(() => {
              for (let index = 0; index < 40; index++) {
                setTimeout(() => {
                  this.mapZoom2 = this.mapZoom2 - 0.5;
                }, index * 250);
              }
            }, 0);
          }
          this.startBarTimer();
          this.loopQuizCountdown()
        },
        error: (value) => {},
      });
  }

  getRankedUsers() {
    this.loader.on();
    this.rest.get(`/question-score/${this.session.id}/leaderboard`).subscribe({
      next: (value: any) => {
        // this.rankedUsers = this.users.sort((a, b) => b.points - a.points);
        this.rankedUsers = value;
        // for (let index = 0; index < 33; index++) {
        //   this.rankedUsers = [...this.rankedUsers,...value]
        // }
        this.showRank = true;
        if (this.endQuiz) {
          this.playAudio('./assets/sounds/ClassificaFinale.wav');
        }
        this.loader.off();
      },
      error: (value) => {
        this.loader.off();
      },
    });
  }

  getH() {
    return window.innerHeight - 400 + 'px';
  }

  getMarkerOptions(emoji: string): google.maps.MarkerOptions {
    return {
      icon: {
        url:
          'data:image/svg+xml;charset=UTF-8,' +
          encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
      <!-- Marker -->
      <path
        d="M24 2C15.2 2 8 9.2 8 18c0 11.5 16 28 16 28s16-16.5 16-28C40 9.2 32.8 2 24 2z"
        fill="#000000"
      />

      <!-- Cerchio interno -->
      <circle cx="24" cy="18" r="10" fill="white"/>

      <!-- Emoji -->
      <text
        x="24"
        y="20"
        text-anchor="middle"
        dominant-baseline="middle"
        font-size="20"
      >
        ${emoji}
      </text>
    </svg>
      `),
        scaledSize: new google.maps.Size(32, 32),
      },
    };
  }
}
